import Vue from 'vue'
import axios from 'axios'
import Vueaxios from 'vue-axios'

Vue.use(Vueaxios, axios)
export default {
  OAuthCheck(URL, obj, header, success, error) {
    Vue.axios.post(URL + 'user/check', obj, header).then(
      (response) => {
        success(response.data)
      },
      (response) => {
        error(response)
      },
    )
  },
  getProfile(URL, header, success, error) {
    Vue.axios.get(URL + 'user/profile', header).then(
      (response) => {
        success(response.data)
      },
      (response) => {
        error(response)
      },
    )
  },
  registerUser(URL, obj, header, success, error) {
    Vue.axios.post(URL + 'user/register', obj, header).then(
      (response) => {
        success(response.data)
      },
      (response) => {
        error(response)
      },
    )
  },
  updateProfile(URL, obj, header, success, error) {
    Vue.axios.post(URL + 'user/update', obj, header).then(
      (response) => {
        success(response.data)
      },
      (response) => {
        error(response)
      },
    )
  },
  getWorkshop(URL, header, success, error) {
    Vue.axios.get(URL + 'workshop', header).then(
      (response) => {
        success(response.data)
      },
      (response) => {
        error(response)
      },
    )
  },
  getMyWorkShop(URL, header, success, error) {
    Vue.axios.get(URL + 'user/workshop', header).then(
      (response) => {
        success(response.data)
      },
      (response) => {
        error(response)
      },
    )
  },
  addMyWorkShop(URL, obj, header, success, error) {
    Vue.axios.post(URL + 'workshop/register', obj, header).then(
      (response) => {
        success(response.data)
      },
      (response) => {
        error(response)
      },
    )
  },
  addAssessment(URL, obj, header, success, error) {
    Vue.axios.post(URL + 'workshop/assessment', obj, header).then(
      (response) => {
        success(response.data)
      },
      (response) => {
        error(response)
      },
    )
  },
  dashboard(URL, date, header, success, error) {
    Vue.axios.get(URL + 'dashboard/' + date, header).then(
      (response) => {
        success(response.data)
      },
      (response) => {
        error(response)
      },
    )
  },
  schoolData(URL, header, success, error) {
    Vue.axios.get(URL + 'school', header).then(
      (response) => {
        success(response.data)
      },
      (response) => {
        error(response)
      },
    )
  },
}



// WEBPACK FOOTER //
// ./src/assets/services.js